import React, { useEffect } from 'react';
import { useNavigation } from '../lib/NavigationContext';
import { Shield, Loader2 } from 'lucide-react';

export default function Home() {
  const { navigateTo } = useNavigation();

  useEffect(() => {
    // Redirect automatico alla pagina preventivi
    const timer = setTimeout(() => {
      navigateTo('Quote');
    }, 1000);

    return () => clearTimeout(timer);
  }, [navigateTo]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-slate-100 flex items-center justify-center">
      <div className="text-center">
        <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-blue-600 to-blue-700 flex items-center justify-center mx-auto mb-6 shadow-xl shadow-blue-500/30">
          <Shield className="w-10 h-10 text-white" />
        </div>
        <h1 className="text-3xl font-bold text-slate-800 mb-2">Mobility Safe</h1>
        <p className="text-slate-500 mb-8">Piattaforma Preventivi Dealer</p>
        <div className="flex items-center justify-center gap-2 text-blue-600">
          <Loader2 className="w-5 h-5 animate-spin" />
          <span>Caricamento...</span>
        </div>
      </div>
    </div>
  );
}